import React from 'react'

const DriversSide = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 960 716" xmlSpace="preserve" width={width} height={height}>
    <polyline
      fill="none"
      stroke={color}
      strokeWidth="18.703"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      points="
	16.198,162.234 16.198,432.76 157.473,537.965 "
    />
    <polyline
      fill="none"
      stroke={color}
      strokeWidth="18.703"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      points="
	280.713,580.047 942,360.62 942,141.193 "
    />
    <ellipse transform="matrix(0.2524 -0.9676 0.9676 0.2524 -89.826 718.6217)" fill="none" stroke={color} strokeWidth="9.3515" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="420.163" cy="417.444" rx="92.744" ry="72.897" />
    <ellipse transform="matrix(0.179 -0.9839 0.9839 0.179 395.2134 1092.5258)" fill="none" stroke={color} strokeWidth="9.3515" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="852.21" cy="309.465" rx="60.646" ry="29.456" />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.3515"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
	M88.004,254.423c0,0-35.687,21.375-44.939,54.773s0,72.14,1.322,77.484c1.322,5.344-1.322,21.375,2.643,29.391
	s60.8,61.453,126.888,72.14c66.087,10.687,148.036-9.352,148.036-9.352s-34.056-150.989,99.131-175.007
	c79.635-14.361,104.418,84.164,93.844,117.562c33.044-8.016,252.454-73.476,266.993-77.484
	c14.539-4.008,23.791-10.687,25.113-24.047c1.322-13.359,9.252-78.82,51.548-88.172c26.336-5.823,41.331,26.719,36.044,65.461
	c0,0,43.261-30.726,15.504-120.234c0,0-6.609-12.023-22.47-16.031"
    />
  </svg>
)
export default DriversSide
